export function removeWorkspace(draft, action) {
    const { workspace } = action.payload;
    if (workspace === draft.workspace.current) {
        draft.workspace.current = 'default';
    }
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete draft.workspaces[workspace];
}
